import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { OutreachService } from '../../../services/outreach.service';
import { ConversationViewComponent } from '../conversation-view/conversation-view.component';

/**
 * /admin/people/outreach/conversations/:id - one Sharon conversation, where
 * the freeze and draft alert emails land. The page is the shared conversation
 * view plus the way back; opening it marks the conversation seen.
 */
@Component({
  selector: 'app-outreach-conversation',
  standalone: true,
  imports: [CommonModule, RouterLink, ConversationViewComponent],
  template: `
    <div class="board">
      <a class="back" routerLink="/admin/people/outreach" [queryParams]="{ tab: 'conversations' }">← Outreach</a>
      <div class="notice bad" *ngIf="!id">That is not a conversation number.</div>
      <app-conversation-view *ngIf="id" [conversationId]="id"></app-conversation-view>
    </div>
  `,
  styleUrls: ['./outreach-conversation.component.scss'],
})
export class OutreachConversationComponent implements OnInit {
  id: number | null = null;

  constructor(private route: ActivatedRoute, private outreach: OutreachService) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const n = Number(params.get('id'));
      this.id = Number.isInteger(n) && n > 0 ? n : null;
      if (this.id) this.outreach.markSeen(this.id).subscribe({ error: () => undefined });
    });
  }
}
